import { gql } from "@apollo/client";

export const BREEZE_PAYMENT_UPDATE = gql`
  subscription BreezePaymentUpdate {
    breezePaymentUpdate {
      wcData
      paymentdata
    }
  }
`;

export const CROSSMINT_PAYMENT_UPDATE = gql`
  subscription CrossmintPaymentUpdate {
    crossmintPaymentUpdate {
      wcData
      paymentdata
    }
  }
`;
